import { readableDate } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { Icon, InfoCardInner, styleClassNames, Tooltip } from '@chocolate-soup-inc/cs-frontend-components';
import { getReadableRelationshipType } from '../../../entities/dependants/shared';
import { TGiftType } from '../../../entities/gifts/queries';
import { getReadableGiftType, isDonationGift } from '../../../entities/gifts/shared';
import { isDependant } from '../../../entities/recipients/shared';
import { TShipmentType } from '../../../entities/shipments/queries';
import { useShipmentAddressInfo } from '../../../entities/shipments/shared';
import { TrackingLink } from '../../../entities/shipments/utils';

type TrackingDetailsProps = {
  shipment: any;
  recipientGifts: any[] | null | undefined;
};

const CardRecipientCell = (props: { shipment?: TShipmentType }) => {
  const { addressTypeIcon, recipientName, readableAddressType } = useShipmentAddressInfo(props.shipment);
  return (
    <div className={styleClassNames.inlineLabel}>
      {addressTypeIcon && readableAddressType && (
        <Tooltip autoPlacement={false} message={readableAddressType} placement='bottom'>
          <Icon filled={true} icon={addressTypeIcon} />
        </Tooltip>
      )}
      {recipientName}
    </div>
  );
};

export const TrackingDetailsModal = (props: TrackingDetailsProps) => {
  const { shipment, recipientGifts } = props;
  if (!shipment) return <></>;
  return (
    <>
      <InfoCardInner<TShipmentType>
        data={shipment}
        sections={[
          {
            title: 'Shipment',
            columns: [
              {
                label: 'Delivery Date',
                render: () => readableDate(shipment.shippingDate)
              },
              {
                label: 'Tracking Number',
                render: () => (shipment ? TrackingLink(shipment) : null)
              },
              {
                label: 'Company',
                render: () => shipment.company?.name ?? ''
              },
              {
                label: 'Recipient',
                render: () => <CardRecipientCell shipment={shipment} />
              }
            ]
          }
        ]}
      />
      {recipientGifts?.map((gift, index) => {
        return (
          <InfoCardInner<TGiftType>
            key={gift.id}
            data={gift}
            sections={[
              {
                title: `Gift #${index + 1}`,
                columns: [
                  {
                    label: 'Shipment Order ID',
                    render: () => gift.shipmentId
                  },
                  {
                    label: 'Recipient Name',
                    render: () => gift.recipient.fullName
                  },
                  {
                    label: 'Relationship',
                    render: () => {
                      const recipient = gift.recipient;
                      if (recipient && isDependant(recipient)) return `${getReadableRelationshipType(recipient)} of ${recipient.employee?.fullName}`;
                    }
                  },
                  {
                    label: 'Event Type',
                    render: () => {
                      return getReadableGiftType(gift);
                    }
                  },
                  {
                    label: 'Event Notes',
                    render: () => {
                      return gift.notes;
                    }
                  },
                  {
                    label: 'Event Date',
                    render: () => readableDate(gift.eventDate)
                  },
                  {
                    label: 'Donation',
                    render: () => {
                      const isDonation = isDonationGift({ gift });
                      return isDonation ? 'yes' : 'no';
                    }
                  }
                ]
              }
            ]}
          />
        );
      })}
    </>
  );
};
